import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox" ]

  toggleDiscountTypeSection() {
    const radios = document.getElementsByName('full_qty_amt_discount_setting[discount_type]');
    let selectedValue
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })

    const fullQtySection = document.querySelector("#full_qty_section");
    const fullAmountSection = document.querySelector("#full_amount_section");

    if (selectedValue == "full_amount") {
      fullAmountSection.classList.remove("d-none")
      fullQtySection.classList.add("d-none")
      this.clearFullQtyDetails();
    } else {
      fullAmountSection.classList.add("d-none")
      fullQtySection.classList.remove("d-none")
      this.clearFullAmountDetails();
    }
  }

  // 清除組合價設定區的多餘輸入框
  clearFullAmountDetails() {
    const fullAmountDetails = document.querySelectorAll(".full_amount_detail");
    fullAmountDetails.forEach((detail, index) => {
        if (index !== 0) {
            detail.remove();
        } else {
            // 將所有input清空
            detail.querySelectorAll("input").forEach(input => {
                input.value = '';
            });
        }
    });
  }

  // 清除定價折扣設定區的多餘輸入框
  clearFullQtyDetails() {
    const fullQtyDetails = document.querySelectorAll(".full_qty_detail");
    fullQtyDetails.forEach((detail, index) => {
        if (index !== 0) {
            detail.remove();
        } else {
            // 將所有input清空
            detail.querySelectorAll("input").forEach(input => {
                input.value = '';
            });
        }
    });
  }
}
